import { render, staticRenderFns } from "./eresetpwd.vue?vue&type=template&id=011b0f1c&scoped=true"
import script from "./eresetpwd.vue?vue&type=script&lang=js"
export * from "./eresetpwd.vue?vue&type=script&lang=js"
import style0 from "./eresetpwd.vue?vue&type=style&index=0&id=011b0f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b0f1c",
  null
  
)

export default component.exports